module.exports = new __parcel__URL__("Charlie_Text-Light.d208db0b.woff").toString();